<template>
    <svg width="39" height="39" viewBox="0 0 39 39" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd"
            d="M36.9382 19.5001L25.6204 30.8205L23.7796 28.9823L31.9618 20.8001L2.6 20.8001L2.6 18.2001L31.9618 18.2001L23.7796 10.0205L25.6204 8.17969L36.9382 19.5001Z"
            fill="white" />
    </svg>
</template>